import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
export interface AudioProps {
  base64: string;
  mediaType: string;
  className?: string;
  "aria-label"?: string;
}
export const Audio = t0 => {
  const $ = _c(12);
  let base64;
  let className;
  let mediaType;
  let props;
  if ($[0] !== t0) {
    ({
      base64,
      mediaType,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = base64;
    $[2] = className;
    $[3] = mediaType;
    $[4] = props;
  } else {
    base64 = $[1];
    className = $[2];
    mediaType = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("w-full", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = `data:${mediaType};base64,${base64}`;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <track kind="captions" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t4 = <audio {...props} controls={true} className={t1} src={t2}>{t3}</audio>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};